import api from './api';
import config from '@/config';

// Lightning asset record URL, e.g.
// https://scalecomputing.lightning.force.com/lightning/r/Asset/02iVm0000025UxBIAU/view
// VUE_APP_SALESFORCE_URL is per-environment (sandbox in dev, production in
// prod) — same base Organizations.vue already uses for the Account link.
export const assetUrl = assetId => `${config.VUE_APP_SALESFORCE_URL}/lightning/r/Asset/${assetId}/view`;

const getAccount = async accountId => {
    const client = await api.getClient();
    return await api.handleSuccess(await client.GetSalesForceAccount(accountId));
};

const syncSalesforceAssets = async (accountId) => {
    const client = await api.getClient();
    return api.handleSuccess(await client.SyncSalesforceAssets(accountId));
}

export default {
    getAccount,
    syncSalesforceAssets
};
